import { render } from "./ViewOptions.vue?vue&type=template&id=b8b428f6&scoped=true"
import script from "./ViewOptions.vue?vue&type=script&lang=js"
export * from "./ViewOptions.vue?vue&type=script&lang=js"

import "./ViewOptions.vue?vue&type=style&index=0&id=b8b428f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b428f6"]])

export default __exports__